let PackagesItem = [
    {
        track: 'Junior',
        trackJunior: true,
        trackTitle: "Junior Track",
        trackSubtitle: true,
        trackPrice: "0",
        runningString: true,
        trackButton: "Register",
        // trackLink: 'https://geekle.us/ticketfree/1685700757453x963002276108042200',
        juniorTicket1Name: "Free Ticket",
        juniorTicket1Price: "0.00",
        juniorTicket1Link: "https://geekle.us/ticketfree/1696333621764x126787862745055230",
        juniorTicket2Name: "+ Certified",
        juniorTicket2Price: "9.99",
        juniorTicket2Link: "https://geekle.us/ticket/1699050607989x991060035792797700",
        juniorTicket3Name: "+ Certificate & Recordings",
        juniorTicket3Price: "15.99",
        juniorTicket3Link: "https://geekle.us/ticket/1699051980195x970677100992266200",
    },
    {
        track: 'Full Access',
        trackFull: true,
        trackTitle: "FULL ACCESS 🔥",
        trackSubtitle: "ticket",
        runningString: true,
        // trackFullPrice: "99",
        trackPrice: "199",
        // earlyBird: "early birds price",
        trackDesc: "1",
        trackButton: "Register",
        trackList1: 'Junior and Senior Track Access',
        trackLink: 'https://geekle.us/ticket/1696333582974x464071366191087600',
    },
    {
        track: 'Year',
        trackTitle: "YEAR OF QA ❤️",
        trackSubtitle: "package",
        runningString: true,
        // trackFullPrice: "179",
        trackPrice: "249",
        earlyBird: "one year access",
        trackDesc: "1",
        trackText: true,
        yearTrackText: true,
        trackText1: "One Year Package",
        trackButton: "Register",
        trackLink: 'https://geekle.us/ticket/1695906660695x325849496251269100',
    },
    {
        track: 'Premium',
        newPremium: true,
        trackTitle: "GEEKLE PREMIUM",
        trackSubtitle: "MEMBERSHIP",
        trackPriceApperance: 2,
        trackPrice: "399",
        trackText: true,
        trackText1: "One Year Premium Membership",
        trackDesc: "1",
        trackButton: "BUY",
        trackLink: 'https://geekle.us/ticket/1696847842733x949907249339039700',
        inverseColors: true,
    },
    // {
    //     trackTitle: "TEAM-5",
    //     trackSubtitle: "YEAR GROUP PACKAGE",
    //     trackPriceApperance: 3,
    //     runningString: true,
    //     trackPrice: "999",
    //     trackText: true,
    //     trackText1: "One Year Pass for 5 team members",
    //     trackDesc: "1",
    //     trackButton: "BUY",
    //     trackLink: 'https://geekle.us/ticket/1694109810106x843614570263085000',
    // },
    // {
    //     trackMode: 'Halloween',
    //     trackTitle: "FRANKENSTEIN'S HALLOWEEN 3+1 PACK",
    //     trackSubtitle: true,
    //     trackPrice: "179",
    //     trackText: true,
    //     trackButton: "GRAB SPOOKY DEAL",
    //     trackLink: 'https://geekle.us/ticket/1698044453451x220433225697198100',
    // },
    {
        track: 'Unlimited',
        trackTitle: "UNLIMITED",
        trackSubtitle: "YEAR ENTERPRISE PACKAGE",
        trackPriceApperance: 4,
        runningString: true,
        trackPrice: "Ask Our Manager",
        trackText: true,
        trackText1: "One Year Pass for up to 100 members",
        trackDesc: "1",
        trackButton: "Get Offer",
        trackLink: 'enterprise',
        validDate: '9.06',
    },
];

export default PackagesItem;
